import { render, staticRenderFns } from "./WebcamCaptureOpenCV_Face.vue?vue&type=template&id=f4e53b4c&scoped=true&"
import script from "./WebcamCaptureOpenCV_Face.vue?vue&type=script&lang=js&"
export * from "./WebcamCaptureOpenCV_Face.vue?vue&type=script&lang=js&"
import style0 from "./WebcamCaptureOpenCV_Face.vue?vue&type=style&index=0&id=f4e53b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e53b4c",
  null
  
)

export default component.exports